import { IAuthTypes, InitialStateType } from './index';

type ActionMap<M extends { [index: string]: unknown }> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key;
      }
    : {
        type: Key;
        payload: M[Key];
      };
};

export enum authTypes {
  setAuthType = 'SET_AUTH_TYPE',
}

type IAuthPayload = {
  [authTypes.setAuthType]: InitialStateType['authType'];
};

export type Actions = ActionMap<IAuthPayload>[keyof ActionMap<IAuthPayload>];

export const authReducer = (
  state: InitialStateType,
  action: { type: string; payload: InitialStateType }
): InitialStateType => {
  switch (action.type) {
    case authTypes.setAuthType:
      return action.payload.authType === IAuthTypes.login ||
        action.payload.authType === IAuthTypes.forgotPassword ||
        action.payload.authType === IAuthTypes.loginOTP
        ? {
            ...state,
            authType: action.payload.authType,
            authPayload: {
              loginType: 'phoneNumber',
              identifier: action.payload.authPayload?.identifier ?? '',
              country: action.payload.authPayload?.country ?? '',
            },
          }
        : {
            authType: action.payload.authType,
          };

    default:
      return state;
  }
};
